import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-database-option',
  templateUrl: './database-option.component.html',
  styleUrls: ['./database-option.component.scss']
})
export class DatabaseOptionComponent implements OnInit {

  titleSectionProp: any = {
    class: 'text-center iq-title-box-2',
    title: 'Cloud Database Options',
    titleIcon: ''
  };
  constructor() { }

  ngOnInit(): void {
  }

}
